import { UcoastEl } from '@/scripts/core/UcoastEl'
import { TsDOM as q } from '@/scripts/core/TsDOM'

// Cross-fades the slides of `sections/fading-hero.liquid` and of
// `sections/hero.liquid` in slideshow mode. Both sections stack their slides
// absolutely and hide every one that does not carry `is-active`, so moving that
// class on a timer is the whole job. The fade, wipe, and reduced-motion behavior
// all live in CSS.
export class HeroSlideshow extends UcoastEl {
	static htmlSelector = 'hero-slideshow'

	// Matches the schema minimum. Guards against a 0 that would spin the timer.
	private static readonly MIN_INTERVAL_MS = 3000

	private slides: HTMLElement[] = []
	private activeIndex = 0
	private timer?: number

	override connectedCallback() {
		super.connectedCallback()
		this.slides = Array.from(q.ol('[data-hero-slide]', this) ?? [])

		// One slide has nothing to fade to.
		if (this.slides.length < 2) return

		// Liquid marks the first slide active at render. Use that marked slide.
		const marked = this.slides.findIndex((slide) => slide.classList.contains('is-active'))
		this.activeIndex = marked === -1 ? 0 : marked
		this.slides[this.activeIndex].classList.add('is-active')

		this.start()
	}

	override disconnectedCallback() {
		super.disconnectedCallback()
		this.stop()
	}

	private start() {
		const attr = q.oa(this, 'data-autoplay-interval')
		const parsed = attr ? parseInt(attr, 10) : NaN
		const interval = Number.isFinite(parsed)
			? Math.max(parsed, HeroSlideshow.MIN_INTERVAL_MS)
			: HeroSlideshow.MIN_INTERVAL_MS

		this.timer = window.setInterval(() => this.advance(), interval)
	}

	private stop() {
		if (this.timer) window.clearInterval(this.timer)
		this.timer = undefined
	}

	private advance() {
		const outgoing = this.slides[this.activeIndex]
		this.activeIndex = (this.activeIndex + 1) % this.slides.length
		const incoming = this.slides[this.activeIndex]

		// Keep the outgoing wipe slide below the incoming slide until the next cycle.
		this.slides.forEach((slide) => slide.classList.remove('is-leaving'))
		outgoing.classList.remove('is-active')
		outgoing.classList.add('is-leaving')
		incoming.classList.add('is-active')
	}
}
